var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "birght-dark" },
    [
      _c("el-switch", {
        staticStyle: { display: "block" },
        attrs: {
          "active-color": "#00d0ff",
          "inactive-color": "#868686",
          "active-text": "亮色模式",
          "inactive-text": "深色模式"
        },
        on: { change: _vm.switchChange },
        model: {
          value: _vm.birght,
          callback: function($$v) {
            _vm.birght = $$v
          },
          expression: "birght"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }